<template>
    <div>
        This application has been disconnected from QBO.
    </div>
</template>

<script>
export default{
    mounted(){
        this.$nextTick(()=>{
            const navbar = document.getElementById('Navigationbar');
            if (navbar !== null)
            {
                navbar.remove();
            }
        });
    }
}
</script>